/* eslint-disable graphql/template-strings */
/* eslint-disable max-len */
import { Injectable } from '@angular/core';
import { DocumentNode } from 'graphql';
import * as apollo from 'apollo-link';
import { gql } from 'graphql-tag';
import { filter, first } from 'rxjs/operators';
import {
  MyCertifiedPlantId,
} from '..';

import { GraphqlApiService } from '../../graphql-api/graphql-api.service';

export interface GetCertifiedPlantIdByEmsIdInput {
  emsId: string;
}
const build = (_query: DocumentNode, input: GetCertifiedPlantIdByEmsIdInput, name = 'QueryResult') => {
  const bQuery = `
  query ${ name }(`+
    ( input.emsId !== undefined ? `$emsId: String = ${JSON.stringify(input.emsId).replace(/"(\w+)":/g, '$1:')}` : '' ) + `){
    getCertifiedPlantIdByEmsId(
      ${ input.emsId !== undefined ? 'emsId: $emsId,' : '' }
    ){
      ...mycertifiedplantid
    }
  }`;
  return gql`
  ${bQuery}
  ${_query}
`};

@Injectable({
  providedIn: 'root',
})
export class GetCertifiedPlantIdByEmsIdQuery {
  readonly graphqlClient$ = this.graphqlApiService.client$.pipe(
    filter((available) => !!available),
  );

  readonly build = build;

  constructor(
    private readonly graphqlApiService: GraphqlApiService,
  ) { }

  /**
   * fragment mycertifiedplantid on MyCertifiedPlantId { ... }
   */
  async execute(_query: DocumentNode, input: GetCertifiedPlantIdByEmsIdInput, refresh = false) {
    const client = await this.graphqlClient$.pipe(first()).toPromise();
    if (!client) {
      throw Error('Missing graphql client!');
    }
    const fetchPolicy = refresh ? 'network-only' : 'cache-first';
   return await client?.query<{ getCertifiedPlantIdByEmsId: Partial<MyCertifiedPlantId> }>({ query: build(_query, input), fetchPolicy });
  }
}
